export default __webpack_public_path__ + "static/media/status-warn-icon.95457687.svg";